module.exports = __webpack_public_path__ + "assets/img/jtfx31.8eab4e82.jpg";